import React, { Component, createRef } from 'react'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'

import Icon from '../Icon'
import SelectUi from '../Select/Select'
import Tooltip from '../Tooltip/Tooltip'

import { formatData, moveArrayItemToNewIndex, alphabeticallySort, capitalize } from '../../utils/formatData'
import isTextEllipsisShown from "../../utils/isTextEllipsisShown"

import './uploadModalStyles.scss'

const accessSelect = (func) => (e) => func(e)

const keyListener = (keyListenersMap) => {
  function keyListener (e) {
    const listener = keyListenersMap.get(e.keyCode)
    return listener && listener(e)
  }

  document.addEventListener('keydown', keyListener)
  return () => document.removeEventListener('keydown', keyListener)
}

class UploadModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      searchValue: '',
      tooltipTarget: null
    }

    this.modalRef = createRef()
    this.noFiles = ''
  }

  componentDidMount() {
    const { selectedRepo } = this.props

    if (selectedRepo && Object.keys(selectedRepo).length) {
      const indexRoot = Object.keys(selectedRepo.Files).indexOf('root')
      const lengthItems = Object.keys(selectedRepo.Files).length

      this.setState({ data: moveArrayItemToNewIndex(Object.keys(selectedRepo.Files), indexRoot, lengthItems - 1) })
    }

    this.modalRef.current.focus()
    const keyListenersMap = new Map([[27, this.props.handleCloseModal]])

    keyListener(keyListenersMap)
  }

  componentDidUpdate (prevProps) {
    const { selectedRepo } = this.props
    if (prevProps.selectedRepo !== selectedRepo) {
      if (selectedRepo && Object.keys(selectedRepo).length) {
        const indexRoot = Object.keys(selectedRepo.Files).indexOf('root')
        const lengthItems = Object.keys(selectedRepo.Files).length

        this.setState({ data: moveArrayItemToNewIndex(Object.keys(selectedRepo.Files), indexRoot, lengthItems - 1) })
      }
    }
  }

  onSearchChange = (e) => {
    const { dataToFilter, updateParentState, selectedRepo } = this.props

    const value = e.target.value
    this.setState({ searchValue: value })

    if (selectedRepo && Object.keys(selectedRepo).length) {
      const filtered = dataToFilter.Files.root.filter((item) => item.Path.toLowerCase().includes(value.toLowerCase()))

      this.noFiles = filtered.length === 0 ? 'No results found' : ''
      updateParentState('selectedRepo', {
          ID: selectedRepo.ID,
          Name: selectedRepo.Name,
          Files: { ...dataToFilter.Files, root: filtered }
      })
    }
  }

  breadcrumbNavigation = (key) => () => {
    const { updateParentState, breadcrumbData, selectedRepo, repoFiles } = this.props

    const keyLower = key.toLowerCase()
    if (keyLower === 'root') {
      repoFiles.map((repo) => {
        if (repo.Name === selectedRepo.Name) {
          const filesObject = { ID: selectedRepo.ID, Name: selectedRepo.Name, Files: formatData(repo.Files, keyLower) }

          updateParentState('selectedRepo', filesObject)
          updateParentState('dataToFilter', filesObject)
          updateParentState('breadcrumbData', ['root'])
        }
      })
    } else {
      repoFiles.map((repo) => {
        if (repo.Name === selectedRepo.Name) {
          const path = repo.Files[repo.Files.length -1].Path.toLowerCase()
          const splittedPath = path.split('/')
          splittedPath.pop()
          if (splittedPath[splittedPath.length - 1] === keyLower) return false

          const filesObject = { ID: selectedRepo.ID, Name: selectedRepo.Name, Files: formatData(formatData(repo.Files, keyLower)[keyLower], keyLower) }

          updateParentState('selectedRepo', filesObject)
          updateParentState('dataToFilter', filesObject)
        }
      })
      breadcrumbData.length = breadcrumbData.indexOf(key) + 1
      updateParentState('breadcrumbData', breadcrumbData)
    }
  }

  getFilesToShow = (key) => {
    const { selectedRepo, supportedFiles } = this.props
    const files = selectedRepo.Files[key] && selectedRepo.Files[key].reduce((acc, file) => {
      const fileTypes = file.Path.split('.')
      const fileType = fileTypes[fileTypes.length - 1]
      const isSupportedFormat = supportedFiles.length === 0 || supportedFiles.some((format) => fileType === format.toLowerCase())

      acc = isSupportedFormat ? acc.concat(file) : acc
      return acc
    }, [])

    return files && alphabeticallySort(files, 'Path')
  }

  hideTooltip = () => () => {this.setState({ tooltipTarget: null })}

  showTooltip = (fileElementID, fileName) => () => {this.setState({ tooltipTarget: { id: fileElementID, name: fileName }})}

  render () {
    const { title = 'Repository', cancelText = 'Cancel', acceptText = 'Select', handleCloseModal, filteredRepos,
      selectRepo, breadcrumbData, selectedRepo, onSelectFile, onClickFolder, handleSelectFiles, validationMessages } = this.props
    const { searchValue, data, tooltipTarget } = this.state

    const ellipsisIsShown = tooltipTarget && isTextEllipsisShown(`.file-item-inner[id="${tooltipTarget.id}"]`)

    return (
      <>
        <div className='modal-bg'/>
          <div
            id="upload-modal"
            className='upload-modal-wrapper'
            aria-labelledby="upload repository modal"
            aria-describedby="upload repository modal"
            role='dialog'
            aria-modal="true"
            autoFocus={false}
          >
            <div className='title' id="uploadDialogTitle">
              <div>{title}</div>
              <button ref={this.modalRef} autoFocus className="close-btn" onClick={handleCloseModal}>
                <Icon name='closeBig.svg' width="20px" height="20px" classes="i"/>
              </button>
            </div>
            <div className="bodyWrapper">
              <div className='nav-line'>
                {filteredRepos.length <= 0
                  ? 'No supported repositories'
                  : filteredRepos.length > 1
                    ? <div className='repo-drop-select capitalize'>
                      <SelectUi
                        tabIndex='0'
                        value={selectedRepo.ID}
                        optionsEnums={filteredRepos}
                        onInputChanged={selectRepo}
                        onKeyPress={accessSelect(selectRepo)}
                      />
                    </div>
                    : <span className='title-repo capitalize'>{filteredRepos.length > 0 && filteredRepos[0].Name}</span>
                }
                <div className='search-input-wrapper'>
                  <div className='search-icon-wrapper'>
                    <Icon name='search.svg' width="15px" height="30px" classes="folder-icon" />
                  </div>
                  <input value={searchValue} className='search-input' type='text' placeholder='Search' onChange={this.onSearchChange}/>
                </div>
              </div>
              <Breadcrumb className="nav-breadcrumb">
                {breadcrumbData.map((key, index) => {
                    const item = key.replace(':', '')
                    return (
                      <BreadcrumbItem key={key} className={`breadcrumbItem_${index}`} onClick={this.breadcrumbNavigation(key, index)} tag="a" href="#">
                        <span>{filteredRepos.length <= 0 ? '' : item === 'root' ? 'All files' : item}</span>
                      </BreadcrumbItem>
                    )
                  })
                }
              </Breadcrumb>
              {validationMessages.map((msg, index) => <div key={index} className={'duc-error duc-error-modal'}>{msg}</div>)}
              <div className="wrapper-file-">
                {selectedRepo && Object.keys(selectedRepo).length
                  ? data.length && data.map((key, index) => {
                    const item = key.replace(':', '')
                    const filesToShow = this.getFilesToShow(key)
                    return (
                      key !== 'root'
                        ? <div
                          key={`${key}_${index}`}
                          className={`file-item capitalize folder folder_${index}`}
                          onClick={onClickFolder(key)}
                          onKeyPress={accessSelect(onClickFolder(key))}
                          data-aria={key}
                          tabIndex='0'
                        >
                          <div className="folder-wrapper file-item-inner">
                            <Icon
                              name='folder.svg'
                              width="30px"
                              height="30px"
                              classes="folder-icon"
                            />
                            {item}
                          </div>
                        </div>
                        : filesToShow.length > 0
                        ? filesToShow.map((file, index) => {
                          const fileTypes = file.Path.split('.')
                          const fileType = fileTypes[fileTypes.length - 1]
                          const fileElementId = `${file.Path}_${index}`
                          return (
                            <div className={`file-item file ${file.selected ? 'selected' : ''}`} key={`${file.Path}_${index}`}>
                              <div
                                className='file-item-inner'
                                onKeyPress={accessSelect(onSelectFile)}
                                onClick={onSelectFile}
                                data-name={file.Path}
                                data-fullpath={file.fullPath}
                                tabIndex='0'
                                id={fileElementId}
                                onMouseLeave={this.hideTooltip()}
                                onMouseEnter={this.showTooltip(fileElementId, file.Path)}
                              >
                                <Icon name={`${fileType}.svg`} width="30px" height="30px" classes="folder-icon"/>
                                {capitalize(file.Path)}
                              </div>
                            </div>
                          )
                        })
                      : <div className="no-files">{this.noFiles}</div>
                    )
                  })
                  : ''
                }
              </div>
              <div className="buttonsWrapper">
                <button className="button confirm-btn" onClick={handleSelectFiles}>{acceptText}</button>
                <button className="button cancelButton" onClick={handleCloseModal}>{cancelText}</button>
              </div>
              {tooltipTarget && ellipsisIsShown &&
                <Tooltip
                  isOpen
                  hideArrow
                  placement="bottom-end"
                  text={tooltipTarget.name}
                  target={document.querySelector(`.file-item-inner[id="${tooltipTarget.id}"]`)}
                />
              }
            </div>
          </div>
      </>
    )
  }
}

export default UploadModal
